export const addFieldOperationsLayer = (
  map: mapboxgl.Map,
  fieldOperationsData: any
): void => {
  if (!fieldOperationsData || !map) return;
  const { image_location: imageUrl, bbox } = fieldOperationsData;
  const sourceId = "field-operations-source";
  const layerId = "field-operations-layer";
  if (map.getLayer(layerId)) {
    map.removeLayer(layerId);
  }
  if (map.getSource(sourceId)) {
    map.removeSource(sourceId);
  }

  // Add the image source
  map.addSource(sourceId, {
    type: "image",
    url: imageUrl,
    coordinates: bbox,
  });

  // Add the image layer
  map.addLayer({
    id: layerId,
    type: "raster",
    source: sourceId,
    paint: {
      "raster-opacity": 0.85,
    },
  });

  // Clean up on unmount ? not required as we clear layer on each call
};

export const removeFieldOperationsLayer = (map: mapboxgl.Map): void => {
  if (!map) return;

  const sourceId = "field-operations-source";
  const layerId = "field-operations-layer";

  if (map.getLayer(layerId)) {
    map.removeLayer(layerId);
  }
  if (map.getSource(sourceId)) {
    map.removeSource(sourceId);
  }
};
